var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 20H3v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7l-5-5H4a1 1 0 0 0-1 1v6h2V4h10v4h4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 11.25h2.197a2.303 2.303 0 1 1 0 4.606H4.5v1.894H3zm1.5 3.106h.697a.803.803 0 0 0 0-1.606H4.5zM8 11.25h1.75A2.75 2.75 0 0 1 12.5 14v1a2.75 2.75 0 0 1-2.75 2.75H8zm1.5 1.5v3.5h.25c.69 0 1.25-.56 1.25-1.25v-1c0-.69-.56-1.25-1.25-1.25zm3.5-1.5h3.75v1.5H14.5v1.606h1.25v1.5H14.5v1.894H13z",
  clipRule: "evenodd"
})));
export default SvgPdf;